import { z } from 'zod';
import { SignalCreateInputSchema } from '@terra/shared-schemas-orchestrator';
import { MongoObjectIdSchema } from '@terra/shared-utils';

export const SignalHttpCreateInputSchema = SignalCreateInputSchema.and(
  z.object({
    constituentFindingIds: z.array(MongoObjectIdSchema).min(2).optional(),
  }),
);

export type SignalHttpCreateInput = z.infer<typeof SignalHttpCreateInputSchema>;
